/** @jsx jsx */
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import { Container, Row, Column } from '../../../styles/Grid';
import OffsetColumn from '../../ui/OffsetColumn';
import Spacer from '../../ui/Spacer';
import Picture from '../../ui/Picture';
import Carousel from '../../ui/Carousel';
import { componentHasStickyLabel } from '../StickyBar';
import { Breakpoints } from '../../../styles/Grid/GridSizes';
import { CLOUDINARY_BASE_VALUES } from '../../../utils/constants';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import LinkWrapper from '../../ui/LinkWrapper';
import {
  containerMarginCss,
  quoteTextCss,
  initialQuote,
  attributionCss,
  headshotCss,
  attributionMainTextCss,
  attributionSecondaryTextCss,
  readTheFullStoryCtaCss,
  blockquoteCss,
  carouselColumnCss,
  spacerCss,
  ctaContainer,
  carouselCss,
  imageCss,
} from './index.styles';

export const defaultData = {
  QuoteText: {
    value:
      'Regus give us the ability to grow quickly while maintaining the employee experience.',
  },
  Headshot: {
    value: {
      src: '',
      alt: '',
    },
  },
  AttributionMainText: { value: 'John Doe' },
  AttributionSecondaryText: { value: 'Managing Director at Microsoft' },
  ReadTheFullStoryCta: {
    value: {
      href: '#',
      text: 'Read the full story',
    },
  },
  QuoteStories: {
    value: [],
  },
};

const HeadshotSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    width: 40,
    height: 40,
    gravity: 'auto:face',
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    width: 40,
    height: 40,
    gravity: 'auto:face',
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    width: 40,
    height: 40,
    gravity: 'auto:face',
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
    aspectRatio: '1:1',
    width: 40,
    height: 40,
    gravity: 'auto:face',
  },
};

export class SolutionQuote extends SafePureComponent {
  safeRender() {
    const { props } = this;
    const fields = defaultsDeep(props.fields, defaultData);
    const hasStickyLabel = componentHasStickyLabel(props);
    const {
      QuoteText,
      Headshot,
      AttributionMainText,
      AttributionSecondaryText,
      ReadTheFullStoryCta,
      QuoteStories,
    } = fields;

    return (
      <Spacer
        customCss={spacerCss}
        marginCss={containerMarginCss}
        containerProps={{
          'data-sticky-id': hasStickyLabel && get(props, 'rendering.uid'),
        }}
      >
        <Container>
          <Row>
            <Column cols={{ md: 6, lg: 4 }} offsets={{ md: 1, lg: 0 }}>
              <blockquote
                cite={ReadTheFullStoryCta.value.href}
                css={blockquoteCss}
              >
                <p css={quoteTextCss}>
                  <span css={initialQuote}>{'”'}</span>
                  <Text field={QuoteText} />
                  {'”'}
                </p>
                <footer css={attributionCss}>
                  <Picture
                    pictureCss={headshotCss}
                    imageCss={imageCss}
                    image={Headshot}
                    imageSizes={HeadshotSizes}
                  />
                  <div>
                    <p css={attributionMainTextCss}>
                      <Text field={AttributionMainText} />
                    </p>
                    <p css={attributionSecondaryTextCss}>
                      <Text field={AttributionSecondaryText} />
                    </p>
                  </div>
                </footer>
                <div css={ctaContainer}>
                  <LinkWrapper
                    type="secondary"
                    css={readTheFullStoryCtaCss}
                    field={ReadTheFullStoryCta}
                  />
                </div>
              </blockquote>
            </Column>
            <OffsetColumn
              css={carouselColumnCss}
              cols={{ sm: 12, lg: 7 }}
              offsets={{ sm: 0, lg: 1 }}
            >
              <Carousel items={QuoteStories} customCss={carouselCss} />
            </OffsetColumn>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

SolutionQuote.displayName = 'SolutionQuote';

SolutionQuote.defaultProps = { fields: defaultData };

const stringPropShape = {
  value: PropTypes.string,
};

SolutionQuote.propTypes = {
  QuoteText: PropTypes.shape(stringPropShape),
  Headshot: PropTypes.shape({
    value: PropTypes.shape({
      src: PropTypes.string,
      alt: PropTypes.string,
    }),
  }),
  MoreStoriesTitle: PropTypes.shape(stringPropShape),
  AttributionMainText: PropTypes.shape(stringPropShape),
  AttributionSecondaryText: PropTypes.shape(stringPropShape),
  ReadTheFullStoryCta: PropTypes.shape({
    value: PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
  }),
};

export default SolutionQuote;
